module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_location_pin-5ad85ca93216c26fee10e38ffe834b2b.svg";